module.exports = __webpack_public_path__ + "static/media/DSC_0175.bf0eaf9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0175.jpg
// module id = 563
// module chunks = 0